import { Serializable } from '@admin/core/models/serializable';
import { StaticContentRawModel } from './static-content-raw-model';

export class StaticContentSubmitDataModel
  implements Serializable<StaticContentSubmitDataModel>
{
  fromObject(obj: any): StaticContentSubmitDataModel {
    Object.assign(this, obj);

    if (obj.primaryData != null) {
      let t = new StaticContentRawModel();
      t = t.fromObject(obj.primaryData);
      this.primaryData = t;
    }

    if (obj.alternativeData != null) {
      let t = new StaticContentRawModel();
      t = t.fromObject(obj.alternativeData);
      this.alternativeData = t;
    }

    return this;
  }
  toObject() {
    let result = {
      PrimaryData: this.primaryData,
      AlternativeDate: this.alternativeData,
    };
    return result;
  }

  public primaryData: StaticContentRawModel;
  public alternativeData: StaticContentRawModel;
}
